import { getInstanceId } from '@va/dashboard/selectors/app';
import { useFetchData } from '@va/util/hooks';
import { post, remove } from '@va/http-client';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

export const useGetIgnoredIps = () => {
  const websiteId = useSelector(getInstanceId);

  return useFetchData<string[], Error>(`/websites/${websiteId}/ignored-ips`);
};

export const useAddNewIgnoredIp = () => {
  const websiteId = useSelector(getInstanceId);
  const addNewIgnoredIp = useCallback(
    async (ip: string) => {
      await post(`/websites/${websiteId}/ignored-ips`, {}, { ip });
    },
    [websiteId],
  );
  return { addNewIgnoredIp };
};

export const useRemoveIgnoredIp = () => {
  const websiteId = useSelector(getInstanceId);
  const removeIgnoredIp = useCallback(
    async (ip: string) => {
      await remove(`/websites/${websiteId}/ignored-ips?ip=${ip}`);
    },
    [websiteId],
  );
  return { removeIgnoredIp };
};
